import { z } from 'zod'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'
import { toStandardSchema } from '../utils/schema'

export const HARMONY_PACKAGE_DOCUMENT_TABLE = '"public"."harmonyPackageDocuments"'

const harmonyPackageDocumentBaseSchema = z.object({
  id: z.string().min(5, 'Document ID is required').default('-----'),
  name: z.string().min(1, 'Document name is required').default('New Document'),
  image: z.string().nullish(),
  context: z.string().nullish(),
  document: z.any().nullish(),
  publish_status: z.string().nullish(),
  created_at: z.coerce.date().default(() => new Date()),
  updated_at: z.coerce.date().default(() => new Date()),
  package_id: z.string().min(1, 'Package ID is required'),
  last_indexed_at: z.coerce.date().nullish(),
  rag_one_liner: z.string().nullish(),
  rag_summary: z.string().nullish(),
  markdown: z.string().nullish(),
  workspace_id: z.uuid('Workspace ID must be a valid UUID'),
  folder_id: z.string().nullish(),
  package: z.any().nullish(),
  workspace: z.any().nullish(),
})

export const HarmonyPackageDocumentSchema = toStandardSchema(harmonyPackageDocumentBaseSchema)

export const HarmonyPackageDocumentConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_DOCUMENT_TABLE,
  partitionKey: 'package_id',
  key: 'id',
  apiEndpoint: '/api/harmony-package-documents',
  where: {},
  schema: HarmonyPackageDocumentSchema,
}
